import { render, staticRenderFns } from "./paymentLog.vue?vue&type=template&id=218edd5a&scoped=true"
import script from "./paymentLog.vue?vue&type=script&lang=ts"
export * from "./paymentLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218edd5a",
  null
  
)

export default component.exports